<cmps-dialog class="h-100 cmps-cdk-pr-0dot75">
    <!-- intentionally not using background-image -->
    <div class="cmps-teamscall-transcript-import-dialog--icaw">
        <img
            src="assets/intelligent-coach-assist-watermark.svg"
            alt=""
            aria-hidden="true"
        />
    </div>
    <cmps-dialog-header>
        <div class="cmps-teamscall-transcript-import-dialog--header">
            <div>
                <img
                    class="cmps-teamscall-transcript-import-dialog--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div
                class="flex-grow-1 cmps-cdk-font-size-20p cmps-cdk-font-bold cmps-cdk-color-blue-100"
            >
                {{ _i18n._11221_IMPORT_TRANSCRIPTS | translate }}
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    (click)="_service.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="cmps-teamscall-transcript-import-dialog--body">
        <cmps-teamscall-auth
            [class.cmps-cdk-d-block]="authRef.hasValidToken !== true"
            [class.cmps-cdk-pt-0dot5]="authRef.hasValidToken !== true"
            [class.cmps-cdk-text-center]="authRef.hasValidToken !== true"
            (hasValidTokenChange)="_onHasValidTokenChange($event)"
            #authRef
        >
            <cmps-wait-status
                *ngIf="_service.state.pending.reload"
            ></cmps-wait-status>
            <div
                class="flex-column cmps-cdk-d-flex cmps-cdk-pos-relative cmps-cdk-m-2 cmps-cdk-border-radius-5px cmps-cdk-bg-color-grey-200 cmps-cdk-p-1"
                *ngIf="!_service.state.pending.reload"
            >
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-flex-100"
                >
                    <div class="cmps-cdk-mr-1dot5">
                        <div>
                            {{ _i18n._11256_TRANSCRIPTS_FOR | translate }}
                        </div>
                        <div class="cmps-cdk-d-flex">
                            <input
                                class="cmps-form-input"
                                readonly
                                [ngModel]="_service.state.selectedUserName"
                                (click)="_onUserInputClick()"
                            />
                            <button
                                class="cmps-icon-button--no-bg"
                                cmpsIconButton
                                (click)="_onUserInputClick()"
                            >
                                <cmps-icon svgIcon="magnify"></cmps-icon>
                            </button>
                        </div>
                    </div>
                    <div class="cmps-cdk-mr-1dot5">
                        <cmps-date-range
                            [dateRange]="_service.state.dateRange"
                            [maxFromDate]="_service.state.maxDate"
                            [maxToDate]="_service.state.maxDate"
                            fromDatePlacement="bottom-right"
                            toDatePlacement="bottom-right"
                            [labelsOnTop]="true"
                            (dateRangeChange)="_onDateRangeChange($event)"
                        ></cmps-date-range>
                    </div>
                    <div class="cmps-cdk-flex-grow-1">
                        <div>&nbsp;</div>
                        <div
                            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-flex-end"
                        >
                            <button
                                class="cmps-button--sm cmps-cdk-min-w-auto"
                                cmpsButton
                                (click)="_onShowResultsClick()"
                            >
                                <span cmpsButtonLabel>
                                    {{ _i18n._11257_SHOW_RESULTS | translate }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-mt-1 cmps-cdk-p-1"
                    *ngIf="
                        !_service.state.pending.meetings &&
                        (_service.state.meetings == null ||
                            _service.state.meetings.length == 0)
                    "
                >
                    <div class="cmps-cdk-text-center">
                        {{
                            _i18n._11258_NO_TRANSCRIPTS_CAN_BE_FOUND_THAT_MATCH_THE_SELECTED_CRITERIA_
                                | translate
                        }}
                    </div>
                </div>

                <div
                    class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-text-center cmps-cdk-font-size-10p cmps-cdk-mt-1"
                    *ngIf="_service.state.meetings?.length > 0"
                >
                    <div
                        class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-flex-100 cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-300 cmps-cdk-font-bold"
                    >
                        <div class="cmps-cdk-flex-20 cmps-cdk-p-0dot5">
                            {{ _i18n._965_DATE | translate }}
                        </div>
                        <div class="cmps-cdk-flex-30 cmps-cdk-p-0dot5">
                            {{ _i18n._11259_MEETING_TITLE | translate }}
                        </div>
                        <div class="cmps-cdk-flex-30 cmps-cdk-p-0dot5">
                            {{ _i18n._9681_PARTICIPANTS | translate }}
                        </div>
                        <div class="cmps-cdk-flex-10 cmps-cdk-p-0dot5">
                            {{ _i18n._11260_TRANSCRIPT_IN_COMPAS | translate }}
                        </div>
                        <div class="cmps-cdk-flex-10 cmps-cdk-p-0dot5">
                            {{ _i18n._11261_IMPORT_TO_COMPAS | translate }}
                        </div>
                    </div>

                    <div
                        class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-flex-100"
                        [class.cmps-cdk-border-b-width-1p]="!last"
                        [class.cmps-cdk-border-b-solid]="!last"
                        [class.cmps-cdk-border-b-color-grey-300]="!last"
                        *ngFor="
                            let m of _service.state.meetings;
                            let last = last
                        "
                    >
                        <div class="cmps-cdk-flex-20 cmps-cdk-p-0dot5">
                            {{ m.startDate | cmpsDate: 'MM-dd-y h:mm a' }}
                        </div>
                        <div class="cmps-cdk-flex-30 cmps-cdk-p-0dot5">
                            {{ m.subject }}
                        </div>
                        <div class="cmps-cdk-flex-30 cmps-cdk-p-0dot5">
                            {{ m.participantsStr }}
                        </div>
                        <div class="cmps-cdk-flex-10 cmps-cdk-p-0dot5">
                            <span
                                class="cmps-cdk-color-green-100"
                                *ngIf="!m.hasUnImportedTranscript"
                            >
                                {{ _i18n._9297_YES | translate }}
                            </span>
                            <span
                                class="cmps-cdk-color-red-100"
                                *ngIf="m.hasUnImportedTranscript"
                            >
                                {{ _i18n._9298_NO | translate }}
                            </span>
                        </div>
                        <div class="cmps-cdk-flex-10 cmps-cdk-p-0dot5">
                            <button
                                class="cmps-icon-button--sm"
                                cmpsIconButton
                                (click)="_onImportClick(m)"
                                [disabled]="!m.hasUnImportedTranscript"
                            >
                                <cmps-icon
                                    [class.cmps-cdk-bg-color-grey-300]="
                                        !m.hasUnImportedTranscript
                                    "
                                    svgIcon="import"
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="cmps-cdk-text-center cmps-cdk-mt-1"
                    *ngIf="_service.state.pending.meetings"
                >
                    <cmps-wait-status></cmps-wait-status>
                </div>
            </div>
        </cmps-teamscall-auth>
    </cmps-dialog-body>
</cmps-dialog>
